// src/pages/Admin/Photos/components/PhotosFilters.jsx
import React from "react";
import { FiFilter, FiRefreshCw, FiSearch } from "react-icons/fi";

export default function PhotosFilters({
  q,
  setQ,
  categoryFilter,
  setCategoryFilter,
  categoryOptions = [],
  typeFilter,
  setTypeFilter,
  visibilityFilter,
  setVisibilityFilter,
  limit,
  setLimit,
  onSubmit,
  onReset,
  loading,
  total,
}) {
  const currentCategoryValue = categoryFilter === "all" ? "" : categoryFilter;

  const handleCategoryChange = (value) => {
    const cleanValue = value.trim();
    setCategoryFilter(cleanValue === "" ? "all" : cleanValue);
  };

  return (
    <form
      onSubmit={onSubmit}
      className="mb-5 rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 md:p-5"
    >
      <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
        <div className="grid flex-1 grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500">
              Rechercher
            </label>

            <div className="relative">
              <FiSearch className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />

              <input
                type="text"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Titre, tags, fichier..."
                className="w-full rounded-2xl border border-slate-300 bg-white py-2.5 pl-9 pr-3 text-sm outline-none transition focus:border-sky-500 focus:ring-4 focus:ring-sky-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
              />
            </div>
          </div>

          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500">
              Catégorie
            </label>

            <input
              type="text"
              list="media-category-options"
              value={currentCategoryValue}
              onChange={(e) => handleCategoryChange(e.target.value)}
              placeholder="Toutes les catégories"
              className="w-full rounded-2xl border border-slate-300 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-sky-500 focus:ring-4 focus:ring-sky-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            />

            <datalist id="media-category-options">
              {categoryOptions.map((category) => (
                <option key={category} value={category} />
              ))}
            </datalist>
          </div>

          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500">
              Type
            </label>

            <select
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              className="w-full rounded-2xl border border-slate-300 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-sky-500 focus:ring-4 focus:ring-sky-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            >
              <option value="all">Tous les médias</option>
              <option value="image">Images</option>
              <option value="document">Documents</option>
              <option value="video">Vidéos</option>
              <option value="other">Autres</option>
            </select>
          </div>

          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500">
              Visibilité
            </label>

            <select
              value={visibilityFilter}
              onChange={(e) => setVisibilityFilter(e.target.value)}
              className="w-full rounded-2xl border border-slate-300 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-sky-500 focus:ring-4 focus:ring-sky-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            >
              <option value="all">Toutes</option>
              <option value="public">Publiques</option>
              <option value="private">Privées</option>
            </select>
          </div>
        </div>

        <div className="flex flex-col gap-3 xl:min-w-[260px] xl:items-end">
          <div className="flex items-center gap-2">
            <label className="text-xs font-semibold text-slate-500">
              Par page
            </label>

            <select
              value={limit}
              onChange={(e) => setLimit(Number(e.target.value) || 24)}
              className="rounded-xl border border-slate-300 bg-white px-2.5 py-2 text-xs font-semibold outline-none transition focus:border-sky-500 focus:ring-4 focus:ring-sky-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            >
              <option value={12}>12</option>
              <option value={24}>24</option>
              <option value={48}>48</option>
              <option value={96}>96</option>
            </select>
          </div>

          <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row">
            <button
              type="button"
              onClick={onReset}
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 py-2.5 text-xs font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
            >
              <FiRefreshCw className="h-4 w-4" />
              Réinitialiser
            </button>

            <button
              type="submit"
              disabled={loading}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-sky-600 px-5 py-2.5 text-xs font-bold text-white shadow-sm transition hover:bg-sky-700 disabled:cursor-not-allowed disabled:opacity-60"
            >
              <FiFilter className="h-4 w-4" />
              Filtrer
            </button>
          </div>

          <p className="text-right text-xs font-semibold text-slate-500 dark:text-slate-400">
            {loading
              ? "Chargement..."
              : `${total} média${total > 1 ? "s" : ""} trouvé${
                  total > 1 ? "s" : ""
                }`}
          </p>
        </div>
      </div>

      {categoryOptions.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-2 border-t border-slate-200 pt-4 dark:border-slate-800">
          <button
            type="button"
            onClick={() => setCategoryFilter("all")}
            className={
              "rounded-full px-3 py-1.5 text-xs font-bold transition " +
              (categoryFilter === "all"
                ? "bg-sky-600 text-white"
                : "bg-slate-100 text-slate-600 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700")
            }
          >
            Toutes
          </button>

          {categoryOptions.slice(0, 12).map((category) => (
            <button
              type="button"
              key={category}
              onClick={() => setCategoryFilter(category)}
              className={
                "rounded-full px-3 py-1.5 text-xs font-bold transition " +
                (categoryFilter === category
                  ? "bg-sky-600 text-white"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700")
              }
            >
              {category}
            </button>
          ))}

          {categoryOptions.length > 12 && (
            <span className="rounded-full bg-slate-100 px-3 py-1.5 text-xs font-bold text-slate-500 dark:bg-slate-800 dark:text-slate-400">
              +{categoryOptions.length - 12}
            </span>
          )}
        </div>
      )}
    </form>
  );
}